import type { JSX } from "react";
import FunctionIcon from "@entrilia/shared/icons/FunctionIcon.tsx";

import type { DimensionDescriptor, FunctionDescription } from "../../../../../../../../../api/types/svTypes.ts";
import MetaIcon from "../../../../common/MetaIcon.tsx";

export interface IFormulaVariable {
  get key(): string;
  get caption(): string;
  get category(): string;
  icon: () => JSX.Element;
}

export class DimensionFormulaVariable implements IFormulaVariable {
  constructor(private dimension: DimensionDescriptor) {}

  get key(): string {
    return this.dimension.name;
  }
  get caption(): string {
    return this.dimension.caption;
  }
  get category(): string {
    return "Dimension";
  }
  get field(): DimensionDescriptor {
    return this.dimension;
  }
  icon() {
    return <MetaIcon icon={this.dimension.icon} />;
  }
}

export class FunctionFormulaVariable implements IFormulaVariable {
  constructor(private func: FunctionDescription) {}
  get key(): string {
    return this.func.fullName;
  }
  get caption(): string {
    return this.func.fullName;
  }
  get category(): string {
    return this.func.description;
  }
  get field(): FunctionDescription {
    return this.func;
  }
  icon() {
    return <FunctionIcon />;
  }
}
